/**
 * Cuotas en las dos modalidades: americana y decimal.
 *
 * Los proveedores mandan la cuota en decimal (1.43, 2.10) salvo
 * SportsBookPlay, que además manda la americana ya calculada. El panel las
 * muestra en las dos formas porque conviven dos públicos: la decimal es la
 * que se usa en la región y la americana es la que pide el cliente para
 * contrastar contra las casas de Estados Unidos.
 *
 * El formato `-233 [1.43]` no es nuevo: es el que ya usaba el detalle de
 * SportsBookPlay, el único proveedor que traía las dos. Acá se unifica para
 * el resto.
 */

/**
 * Convierte una cuota decimal a la notación americana (moneyline).
 *
 *   >= 2.00  ->  lo que se gana apostando 100  ->  +110
 *   <  2.00  ->  lo que hay que apostar para ganar 100  ->  -233
 *
 * Con cuota 1.00 o menor no hay ganancia posible, así que no hay americana
 * que mostrar y devuelve null.
 */
export function toAmericanOdds(decimal) {
  const valor = Number(decimal);

  if (!Number.isFinite(valor) || valor <= 1) return null;

  const americana = valor >= 2 ? (valor - 1) * 100 : -100 / (valor - 1);
  const redondeada = Math.round(americana);

  return `${redondeada > 0 ? "+" : ""}${redondeada}`;
}

/**
 * Cuota lista para mostrar: `-233 [1.43]`.
 *
 * `american` es para los proveedores que ya la mandan: en ese caso se respeta
 * la del proveedor en vez de recalcularla, que puede redondear distinto.
 * Si no hay americana posible, se muestra la decimal sola antes que un hueco.
 */
export function formatOdds(decimal, american = null) {
  if (decimal === null || decimal === undefined || decimal === "") {
    return american ? String(american) : "-";
  }

  const americana = american ?? toAmericanOdds(decimal);

  return americana ? `${americana} [${decimal}]` : String(decimal);
}
